import React from "react";
import { deleteItemFromLocalStorage, encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from "../../Helpers/Chat/webChatEncryptDecrypt";
import { addCallConnectionDate } from "../../Redux/feature/callConnectionDateSlice";
import { store } from "../../Redux/store";
import callLogsObj from '../../Components/WebCall/CallLogs/callLog';
import { addShowConfrenceData } from "../../Redux/feature/showConfrenceDataSlice";
import { NO_INTERNET } from "../../Helpers/Constants";
import { ToastContainer, toast } from "react-toastify";
import { formatUserIdToJid, getLocalUserDetails, getDataFromRoster } from "../../Helpers/Chat/User";
import { blockOfflineMsgAction, getCallData, themeCustomization } from "../../Helpers/Utility";
import { useSelector } from "react-redux";
import SDK from "../../SDK";
import ringingTone from "../../Components/WebCall/ringingtone";
import outgoingRinging from "../../Components/WebCall/outgoingRingingBase64";
import busySignal from "../../Components/WebCall/busySignalBase64";
import notificationSound from "../../Helpers/Browser/notificationBase64";
import browserTab from "../../Helpers/Browser/BrowserTab";
import browserNotify from "../../Helpers/Browser/BrowserNotify";
import WebRtcCall from "../../Components/WebCall/WebRtcCall";
import WebCallingLayout from "../../Components/WebCall/WebCallingLayout";
import Connecting from "../../Components/WebCall/Connecting";
import CalleeScreen from "../../Components/WebCall/CalleScreen";
import CallConversionPopup from "../../Components/WebCall/CallConversionPopup";
import ParticipantsPopUp from "../../Components/ContactInfo/ParticipantsPopUp";
import ActionPopUp from "../../Components/ContactInfo/ActionPopUp";
import CallParticipantsPopup from "../../Components/WebCall/ParticipantPopUp";
import { REACT_APP_XMPP_SOCKET_HOST } from "../../processENV";
import { muteLocalVideo } from "../../callback";
import {  getMaxUsersInCall, startCallingTimer } from "../../Helpers/Call/Call";
import { CALL_CONVERSION_STATUS_ACCEPT, CALL_CONVERSION_STATUS_CANCEL, CALL_CONVERSION_STATUS_DECLINE, CALL_CONVERSION_STATUS_REQUEST, CALL_CONVERSION_STATUS_REQ_WAITING, PERMISSION_DENIED } from "../../Helpers/Call/Constant";
import { addCustomCall } from "../../Redux/feature/addCustomCallSlice";
import useWindowSize from "../../hooks/useWindowSize";
import { IconLoaderHoc } from "../../assets/images";

export const  CustomCallComponent = (props = {})=>{
    const { userId,darkTheme = true,callType:callTypes,enableDeviceSize,colorSet,theme = "light",iconSet} = props
    const storeselect = useSelector((state) => state); 
    const  mirrorflyInitials = useSelector(state => state.mirrorflyInitial?.data)
    const [hideCallScreen, setHideCallScreen] = React.useState(false);
    const showConfrenceData = useSelector((state) => state.showConfrenceData);
    const { popUpData:{ modalProps: { open, modelType } }, callConversionData:callConversionDataa } = storeselect 
    const { appOnlineStatus : {isAppOnline} } = storeselect
    const [currentUserRequestingCallSwitch, setCurrentUserRequestingCallSwitch] = React.useState(false);
    const [remoteUserRequestingCallSwitch, setremoteUserRequestingCallSwitch] = React.useState(false);
    const callConnectionDate = JSON.parse(getFromLocalStorageAndDecrypt("call_connection_status"));
    const [enableMobileView, setEnableMobileView] = React.useState(false)
    encryptAndStoreInLocalStorage("hideCallScreen", false);
    const windowSize = useWindowSize();
    const { 
        vCardData
    } = storeselect;

    React.useEffect(()=>{
        themeCustomization(theme,colorSet,iconSet)
    },[])
    
    React.useEffect(()=>{
        if(document.getElementById("mf-root-Parent").parentElement.offsetWidth < 1025){
            setEnableMobileView(true)
        } else {
            setEnableMobileView(false)
        }
    },[windowSize])

    React.useEffect(()=>{
        if(blockOfflineMsgAction()) return
        async function changeActiveChatData() {
            let userList = []
            if(!userId){return}
            let userListData = await getCallData(userId)
            userList = [...userListData]
            makeOne2OneCall(callTypes,userList)
        }
        mirrorflyInitials && changeActiveChatData()
    },[mirrorflyInitials,props])

    const handleIframeTask = (e) => {
        if (e.data === "returntoChat") {
            setHideCallScreen({ hideCallScreen: true });
        }
        if (e.data === "endcall") {
            store.dispatch(
            addShowConfrenceData({
                ...showConfrenceData,
                showComponent: false
            })
            );
        }
    };

    const resetCallConversionRequestData = () => {
        setCurrentUserRequestingCallSwitch(false);
        setremoteUserRequestingCallSwitch(false);
    }

    React.useEffect(()=>{
        if (callConversionDataa?.data?.status) {
            if (callConversionDataa?.data?.status === CALL_CONVERSION_STATUS_ACCEPT) {
                if (remoteUserRequestingCallSwitch === true && currentUserRequestingCallSwitch === true) {
                setCurrentUserRequestingCallSwitch(false);
                }
                setremoteUserRequestingCallSwitch(false);
            } else if (callConversionDataa?.data?.status === CALL_CONVERSION_STATUS_REQ_WAITING) {
            setCurrentUserRequestingCallSwitch(true);
            } else if (callConversionDataa?.data?.status === CALL_CONVERSION_STATUS_REQUEST) {
            setremoteUserRequestingCallSwitch(true);
            } else if (callConversionDataa?.data?.status === CALL_CONVERSION_STATUS_CANCEL) {
                resetCallConversionRequestData();
            } else if (callConversionDataa?.data?.status === CALL_CONVERSION_STATUS_DECLINE) {
                resetCallConversionRequestData();
            }
        }
    },[callConversionDataa])

    React.useEffect(()=>{
        if(document.getElementById("mf-root-Parent").parentElement.offsetWidth > 1024){
            window.addEventListener('resize', () => {
            if(enableDeviceSize === true){
                customResize();
            }
            });
            window.removeEventListener('resize', customResizeMw);
        }
        else {
        window.addEventListener('resize', () => {
            if(enableDeviceSize === true){
            customResizeMw();
            }
        });
        window.removeEventListener('resize', customResize);
        }
    },[])

    const customResize = () => {
        document.getElementById('mirrorFlyRoot').style.height = window.innerHeight + "px";
        document.getElementById('mirrorFlyRoot').style.width = window.innerWidth + "px";
        document.getElementById('mirrorFlyRoot').style.maxWidth = "100%";
    }
    const customResizeMw = () => {
        document.getElementById('mirrorFlyRoot').style.height = window.innerHeight + "px";
        document.getElementById('mirrorFlyRoot').style.width = "100%";
        document.getElementById('mirrorFlyRoot').style.maxWidth = window.innerWidth + "px";
    }

    React.useEffect(()=>{
        window.addEventListener("message", handleIframeTask);
        window.ringingTone = new Audio(ringingTone)
        window.outgoingRingTone = new Audio(outgoingRinging)
        window.busySignal = new Audio(busySignal)
        window.notifySound = new Audio(notificationSound)
        browserTab.init();
        browserNotify.init();
        if(document.getElementById("mf-root-Parent").parentElement.offsetWidth < 1025){
            setEnableMobileView(true);
            if(enableDeviceSize === true){
            customResizeMw()
            }
        }
    },[])

    const hideCallScreenAction = () => {
        encryptAndStoreInLocalStorage("hideCallScreen", true);
        setHideCallScreen(true);
    };
    

    const makeCall = async (callMode, callType, groupCallMemberDetails, groupId = null) => {
        let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
        if (connectionStatus === "CONNECTED") {
            let users = [], roomId = "", call = null, image = "";
            const vcardData = getLocalUserDetails();
            let fromuser = formatUserIdToJid(vcardData.fromUser);

            if (callMode === "onetoone") {
                users = groupCallMemberDetails;
            } else if (callMode === "onetomany") {
                if (groupCallMemberDetails.length > 0) {
                    groupCallMemberDetails.forEach(function (member) {
                        if (member !== fromuser) {
                            if (typeof member === "object")
                                users.push(member.userJid);
                            else
                                users.push(member);
                        }
                    });
                } else {
                    users = [""];
                }
            }

            let callConnectionStatus = {
                callMode: callMode,
                callStatus: "CALLING",
                callType: callType,
                from: fromuser,
                userList: users.join(","),
            }
            if (callMode === "onetoone") {
                callConnectionStatus.to = users.join(",");
                callConnectionStatus.userAvatar = image;
            } else if (callMode === "onetomany") {
                callConnectionStatus.to = groupId;
                callConnectionStatus.groupId = groupId;
            }
            store.dispatch(addCustomCall(true))
            encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatus))
            encryptAndStoreInLocalStorage('callType', callType)
            encryptAndStoreInLocalStorage('callingComponent', true)
            encryptAndStoreInLocalStorage('callFrom', getFromLocalStorageAndDecrypt('loggedInUserJidWithResource'));
            store.dispatch(addCallConnectionDate(callConnectionStatus));
            const {  data: confrenceData } = showConfrenceData
            store.dispatch(addShowConfrenceData({
                localStream: confrenceData?.localStream,
                localVideoMuted: confrenceData?.localVideoMuted,
                localAudioMuted: confrenceData?.localAudioMuted,
                showComponent: true,
                callStatusText: 'Calling'
            }))
            try {
                if (callType === "audio") {
                    muteLocalVideo(true);
                    call = await SDK.makeVoiceCall(users, groupId);
                } else if (callType === "video") {
                    muteLocalVideo(false);
                    call = await SDK.makeVideoCall(users, groupId);
                }
                if (call.statusCode !== 200 && call.message === PERMISSION_DENIED) {
                    deleteItemFromLocalStorage('roomName')
                    deleteItemFromLocalStorage('callType')
                    deleteItemFromLocalStorage('call_connection_status')
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    encryptAndStoreInLocalStorage('callingComponent', false)
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    store.dispatch(addShowConfrenceData({
                        showComponent: false,
                        showCalleComponent: false,
                        stopSound: true,
                        callStatusText: null
                    }))
                } else {
                    roomId = call.roomId;
                    callLogsObj.insert({
                        "callMode": callConnectionStatus.callMode,
                        "callState": 1,
                        "callTime": callLogsObj.initTime(),
                        "callType": callConnectionStatus.callType,
                        "fromUser": callConnectionStatus.from,
                        "roomId": roomId,
                        "userList": callConnectionStatus.userList,
                        ...(callMode === "onetomany" && {
                            "groupId": groupId
                        })
                    });
                    encryptAndStoreInLocalStorage('roomName', roomId)
                    let callConnectionStatusNew = {
                        ...callConnectionStatus,
                        roomId: roomId
                    }
                    encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatusNew))
                    store.dispatch(addCallConnectionDate(callConnectionStatusNew));
                    startCallingTimer();
                }
            } catch (error) {
                console.log("Error in making call", error);
                if (error.message === PERMISSION_DENIED) {
                    deleteItemFromLocalStorage('roomName')
                    deleteItemFromLocalStorage('callType')
                    deleteItemFromLocalStorage('call_connection_status')
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    encryptAndStoreInLocalStorage('callingComponent', false)
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    store.dispatch(addShowConfrenceData({
                        showComponent: false,
                        showCalleComponent: false,
                        stopSound: true,
                        callStatusText: null
                    }))
                }
            }
            // // preventMultipleClick = false;
        } else {
            toast.error(NO_INTERNET)
            // // preventMultipleClick = false;
        }
    }

    const makeOne2OneCall = async (callType,usersList) => {
        const roomName = getFromLocalStorageAndDecrypt('roomName');
        if (roomName) {
            toast.info("Can't place a new call while you're already in a call.");
            return;
        }
        let callMode = "onetoone";
        let users = [];
        const maxMemberReached = Boolean(usersList.length > (getMaxUsersInCall() - 1));
        if (maxMemberReached) {
            toast.error("Maximum " + getMaxUsersInCall() + " members allowed in a call");
            return;
        }
        if (usersList.length > 1) {
            callMode = "onetomany";
            users = usersList;
        } else {
            usersList.map(participant => {
                const { userJid, username, GroupUser } = participant
                let user = userJid || username || GroupUser;
                user = user.split('@')[0];
                let userDetails = getDataFromRoster(user);
                if (!userDetails.isDeletedUser) {
                    users.push(user + "@" + REACT_APP_XMPP_SOCKET_HOST);
                }
            });
        }
        if (users.length === 1 ) {
            makeCall(callMode, callType, users, "");
        }else if(users.length > 1) {
            makeCall(callMode, callType, users, "");
        }else{
            if(toast.error.length > 1) {
                toast.dismiss();
                // // toast.error(FEATURE_RESTRICTION_ERROR_MESSAGE);
            } 
        }
    }

    return (
        <>
    <div id="mirrorFlyRoot" className={`mirrorfly-root ${ enableMobileView === true ? " mobileView " : " " }`}>
        <div className={` ${darkTheme ? " dark-theme-active " : " "} boxLayout`}>
            <div className="container containerLayout" id="container">
        {!mirrorflyInitials ? <div className="page-loader"> <IconLoaderHoc style={{ width: "80px", height: "80px" }} /> </div> : null}
            {showConfrenceData.data.showCalleComponent && (
            <div className={`${(hideCallScreen && "BackToConversion") || ""}`}> 
                <CalleeScreen
                    callStatus={showConfrenceData.data.callStatusText}
                    stopSound={showConfrenceData.data.stopSound || ""}
                    hideCallScreen={hideCallScreenAction}  
                    endCallAction={props.endCallAction}  
                    />  
                </div>
            )} 
            {showConfrenceData.data &&
            vCardData &&
            vCardData.data &&
            showConfrenceData.data.showComponent && 
            (
                <div className={`connecting webrtc  ${(hideCallScreen && "visible") || ""}`}>
                    <Connecting
                        // jid={jid}
                        fromuser={vCardData.data.fromuser}
                        hideCallScreen={hideCallScreenAction}
                        endCallAction={props.endCallAction}
                    />
                </div>
            )
                }
            {showConfrenceData.data &&
            getFromLocalStorageAndDecrypt("callingComponent") === true && ( 
            <div className={`web_calling_layout ${(hideCallScreen && "BackToConversion") || ""}`}>
                <WebCallingLayout
                    callStatus={showConfrenceData.data.callStatusText}
                    stopSound={showConfrenceData.data.stopSound || ""}
                    soundPath={showConfrenceData.data.soundPath || ""}
                    hideCallScreen={hideCallScreenAction}
                    endCallAction={props.endCallAction}
                />
                </div>
            )} 
            {showConfrenceData.data.showStreamingComponent &&
            callConnectionDate && (
                <div className={`connecting  ${(hideCallScreen && "visible") || ""}`}>
                <WebRtcCall
                    showConfrenceDataId={showConfrenceData.id}
                    remoteVideoMuted={showConfrenceData.data.remoteVideoMuted}
                    remoteAudioMuted={showConfrenceData.data.remoteAudioMuted}
                    localVideoMuted={showConfrenceData.data.localVideoMuted}
                    localAudioMuted={showConfrenceData.data.localAudioMuted}
                    hideCallScreen={hideCallScreenAction}
                    endCallAction={props.endCallAction}
                    fromJid={showConfrenceData.data.fromJid}
                    status={showConfrenceData.data.status}
                    localStream={showConfrenceData.data.localStream}
                    remoteStream={showConfrenceData.data.remoteStream}
                />
                </div>
            )}
            {open && modelType === 'action' && <ActionPopUp {...storeselect.popUpData} />}
            {open && modelType === 'participants' && <ParticipantsPopUp />}
            {open && ['callparticipants', 'inviteParticipants', 'calllogparticipants'].indexOf(modelType) > -1 && <CallParticipantsPopup />}
            {callConversionDataa?.data?.status && isAppOnline &&
            <CallConversionPopup
                callConversionData={callConversionDataa}
                resetCallConversionRequestData={resetCallConversionRequestData}
                currentUserRequestingCallSwitch={currentUserRequestingCallSwitch}
                remoteUserRequestingCallSwitch={remoteUserRequestingCallSwitch}
            />
            }

            <ToastContainer position="top-right" />
            </div>
            </div>
        </div>
        </>
        )
}

